import {
  FormControlState,
  FormGroupState,
  FormArrayState,
  FormControlValueTypes,
  validate,
  setErrors
} from 'ngrx-forms';
import { required } from 'ngrx-forms/validation';

export function requiredWhenEnabled<T extends FormControlValueTypes>(
  s: FormControlState<T>,
  ps: FormGroupState<any>
): FormControlState<T>;
export function requiredWhenEnabled<T>(
  s: FormArrayState<T>,
  ps: FormGroupState<any>
): FormArrayState<T>;
export function requiredWhenEnabled(
  enabledValue: boolean
): <T extends FormControlValueTypes>(s: FormControlState<T>) => FormControlState<T>;
export function requiredWhenEnabled(
  sOrEnabledValue: any,
  ps?: FormGroupState<any>
): any {
  if (typeof sOrEnabledValue === 'boolean') {
    const enabledValue = sOrEnabledValue;
    return (s: any) => {
      return enabledValue ? validate(s, required) : setErrors(s, {});
    };
  }

  if (ps?.controls?.enabled?.value === true) {
    return validate(sOrEnabledValue, required);
  }
  return setErrors(sOrEnabledValue, {});
}
